import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AgePipe } from "../shared/pipes/age.pipe";
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { NotificationService } from '../shared/services/notifications.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';


export interface requestmore {
  serviceRequestId: string,
  documentType: string,
  requestDetails: string,
  requestedAt: string

}


@Component({
  selector: 'app-request-more-details',
  standalone: true,
  imports: [MatIconModule,
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule, AgePipe, HttpClientModule],
  templateUrl: './request-more-details.component.html',
  styleUrl: './request-more-details.component.scss'
})
export class RequestMoreDetailsComponent {

  requestForm !: FormGroup;
  copiedEmail: string | null = null;
  memberId!: string;
  selectedPatient: any;
  details: any = {};
  date = new Date();

  popupTitle = 'Request More Details';
  popupSubtitle = 'You can enter in required details that all you need more to proceed';


  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<RequestMoreDetailsComponent>, private restservice: MemberInsurerRestService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificationService: NotificationService, private memberService: MemberInsurerServiceService) {
    this.requestForm = this.fb.group({
      requestDetails: ['',Validators.required]
    })

    console.log(data)
    if (data) {
      this.memberId = data.patientId;
      if (this.memberId)
        this.getMemberById();
      this.details = data;
    }
  }

  ngOnInit() {

  }

  getMemberById(): void {
    this.restservice.getMemberById(this.memberId).subscribe({
      next: (response) => {
        this.selectedPatient = response;
      },
      error: (err) => {
        console.error('Failed to fetch patient by ID:', err);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  submitForm() {
    let json = {
      serviceRequestId: this.details.serviceRequest.id,
      requestDetails: this.requestForm.value.requestDetails,
      userId : this.memberService.getLoginUserId(),
      role : this.memberService.getLoginUserRole(),
      userName : this.memberService.getLoginUserName()
    }
    this.restservice.onRequestMoreDeatils(json).subscribe({
      next: (value) => {
        this.notificationService.showNotification('Your request sent successfully');
        this.closeDialog();
        this.memberService.emitRefresh();
      },
      error: (err) => {
        this.notificationService.showNotification(err.error.Message, 'error');
      }
    })
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }
}
